import * as yup from "yup";

export const ShopValidationSchema = yup.object().shape({
    name: yup.string().max(50, "Name not more than 50 Characters.").required("Name is Required"),
});
